import React from "react";
import { useLocation } from "react-router-dom";
import FullPage from "../../components/FullPage";
import BemVindo from "../../components/BemVindo";
import Afiliados from "./Section/Afiliados";
import useAffiliate from "../../Hooks/AffiliateContext";
import CadastroMM from "./Section/CadastroMM";
import MinhasVendas from "./Section/MinhasVendas";
import VisaoVendas from "./Section/VisaoVendas";
import usePermission from "../../Hooks/usePermission";

const AfiliadoPage = (props) => {
  const { getShowTo } = usePermission();
  const location = useLocation();
  let path = location.pathname

  const { affiliate, affiliateCanAccess } = useAffiliate();

  const isAffiliated = affiliate ? true : false;
  const isToHidde = !affiliateCanAccess;

  let config = {
    parentUrl: path,
    parentName: "AFILIADOS",
    parentComponent: BemVindo,
    routes: [
      {
        route: "cadastro",
        text: "CADASTRAR",
        component: CadastroMM,
        show: !isAffiliated && getShowTo("AFILIAR"),
      },
      {
        route: "meu-cadastro",
        text: "MEU CADASTRO",
        component: CadastroMM,
        show: isAffiliated && getShowTo("DADOS_CADASTRAIS"),
      },
      {
        route: "afiliados",
        text: "MEUS VENDEDORES",
        component: Afiliados,
        show: (isToHidde || isAffiliated) && getShowTo("MEUS_VENDEDORES"),
      },
      {
        route: "minhas-vendas",
        text: "MINHAS VENDAS",
        component: MinhasVendas,
        show: isAffiliated && getShowTo("MINHAS_VENDAS_AFILIADO"),
      },
      {
        route: "visao-vendas",
        text: "VENDAS AFILIADOS",
        component: VisaoVendas,
        show: getShowTo("VENDAS_AFILIADOS"),
      },
    ],
  };

  return <FullPage {...config} />;
};

export default AfiliadoPage;
